import NumerousLogo from "@/components/logo/NumerousLogo";

const Navbar = () => {
  return (
    <div className="bg-white rounded-md flex justify-between px-9">
      <div className="flex items-center gap-x-1">
        <NumerousLogo type="brandmark" size="sm" className="mr-1" />
        <NumerousLogo type="wordmark" size="sm" />
        <span className="font-thin text-lg">enterprise</span>
      </div>
    </div>
  );
};

export default Navbar;
